/** Evento para que la pantalla abierta vuelva a poner el cursor en su campo principal (ej. después de imprimir). */
export const REFOCUS_EVENT = "sofia:refocus";
export const requestRefocus = () => window.dispatchEvent(new Event(REFOCUS_EVENT));
